export const getAllSearchParams = (searchParams) => {
  let values = {};
  for (const [key, value] of searchParams.entries()) {
    values[key] = value;
  }
  return values;
};
